import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
	TextField,
	Typography,
	Popper,
	Grow,
	IconButton,
	Paper,
	ClickAwayListener,
	InputAdornment,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { CancelOutlined, HelpOutline } from '@material-ui/icons';
import _e from 'common/localeUtil';
import FormStatusComponent from '../FormStatusComponent';
import { handleServerErrorMessage } from '../../../utils/formUtil';
import { colors } from '../../common';

class FieldInputControl extends PureComponent {
	constructor(props) {
		super(props);
		// const {
		//     input: { value }
		// } = props;
		this.focus = this.focus.bind(this);
		// this.state = {
		//     charCount: value ? value.length : 0
		// };
	}

	renderErrorIcon = () => {
		const { meta, popupPlacement } = this.props;
		// console.log(meta?.error);
		return meta.error ? (
			<FormStatusComponent
				popover
				error={handleServerErrorMessage(meta.error)}
				warning={handleServerErrorMessage(meta.warning)}
				popupPlacement={popupPlacement}
			/>
		) : null;
	};

	handleClearContent = () => {
		const { doClearContent } = this.props;
		doClearContent && doClearContent();
	};

	showEndAdornment = () => {
		const {
			endAdornment,
			showClearText,
			classes,
			input: { value },
		} = this.props;
		if (endAdornment) {
			return endAdornment;
		}
		if (showClearText) {
			return (
				<InputAdornment position="end" style={{ display: value ? 'flex' : 'none' }}>
					<IconButton onClick={this.handleClearContent} disableRipple>
						<CancelOutlined className={classes.clearTextIconStyle} />
					</IconButton>
				</InputAdornment>
			);
		}
		return null;
	};

	renderPopover = () => {
		const { helpElement } = this.state;
		const { helpPopupElement, popupPlacement, classes } = this.props;
		return (
			<Popper
				open={Boolean(helpElement)}
				anchorEl={helpElement}
				transition
				placement={popupPlacement}
			>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps} id="menu-list-grow">
						<Paper
							elevation={2}
							classes={{ root: classes.popperStyle }}
							className="flex-container pad-horizontal pad-vertical"
						>
							<ClickAwayListener onClickAway={this.hideHelp}>
								{helpPopupElement}
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		);
	};

	renderHelpIcon = () => {
		const { helpPopupElement, classes } = this.props;
		if (helpPopupElement) {
			return (
				<IconButton classes={{ root: classes.helpButtonStyle }} onClick={this.showHelp}>
					<HelpOutline className={classes.helpIconStyle} />
				</IconButton>
			);
		}
		return null;
	};

	renderCharCount = () => {
		const {
			classes,
			input: { value },
			maxLength,
			help,
		} = this.props;
		const charCount = value?.length || 0;
		return (
			<div
				className={`${classes.charCounterStyle} ${help ? 'has-help' : ''}  flex-container`}
			>
				<Typography variant="caption" color="textSecondary" align="right">
					{_e('char_left', {
						charLeft: parseInt(maxLength, 10) - parseInt(charCount, 10),
					})}
				</Typography>
			</div>
		);
	};

	onChange = (e) => {
		const { input, onChangeCallback } = this.props;
		e.persist();
		input.onChange(e);

		if (onChangeCallback) {
			onChangeCallback(e);
		}
	};

	focus() {
		if (this.ref) {
			this.ref.focus();
		}
	}

	render() {
		const {
			id,
			defaultValue,
			variant,
			helpPopupElement,
			autocomplete,
			showCharCount,
			rowsMax,
			rows,
			showErrorAsPopover,
			multiline,
			placeholder,
			inputClass,
			fullWidth,
			compact,
			startAdornment,
			disabled,
			type,
			input,
			meta,
			label,
			help,
			className,
			required,
			maxLength,
			classes,
			containerClass,
		} = this.props;
		// if (input.name === 'search') console.log(input.name, this.state.value);
		const inputProps = {
			onChange: this.onChange,
			className: inputClass,
			maxLength,
			onFocus: input.onFocus,
			onBlur: input.onBlur,
		};
		const helpNode =
			Boolean(meta.touched && (meta.error || meta.warning)) && !showErrorAsPopover ? (
				<FormStatusComponent
					compact={compact}
					error={_e(meta.error, {}, meta.error)}
					warning={_e(meta.warning, {}, meta.warning)}
				/>
			) : (
				help
			);

		return (
			<div
				className={`flex-container horizontal ${containerClass} ${classes.containerStyle}`}
			>
				{showCharCount && this.renderCharCount()}
				<div className="flex-container flex-full">
					<TextField
						id={id}
						variant={variant}
						fullWidth={fullWidth}
						margin="none"
						multiline={multiline}
						placeholder={placeholder}
						required={required}
						name={input.name}
						type={type}
						rows={rows}
						defaultValue={defaultValue}
						autoComplete={autocomplete}
						rowsMax={rowsMax}
						FormHelperTextProps={{ component: 'div' }}
						helperText={helpNode}
						inputRef={(ref) => {
							this.ref = ref;
						}}
						label={label}
						disabled={disabled}
						value={input?.value || ''}
						error={meta.error && meta.touched}
						InputLabelProps={{
							shrink: false,
							required,
						}}
						InputProps={{
							startAdornment,
							endAdornment:
								Boolean(meta.touched && (meta.error || meta.warning)) &&
								showErrorAsPopover
									? this.renderErrorIcon()
									: this.showEndAdornment(),
						}}
						className={`text-field ${classes.textInputStyle} ${className} ${
							label ? '' : 'no-label'
						}`}

						inputProps={inputProps}
					/>
				</div>
				{helpPopupElement && (
					<div className={`flex-container ${classes.helpContainerStyle}`}>
						{this.renderHelpIcon()}
					</div>
				)}
			</div>
		);
	}
}

const styles = (theme) => ({
	containerStyle: {
		position: 'relative',
	},
	charCounterStyle: {
		transform: `translate(15px, -16px)`,
		zIndex: 1,
		fontStyle: 'italic',
		position: 'absolute',
		transformOrigin: 'bottom left',
		left: 0,
		bottom: 0,
		display: 'inline',
		background: colors.secondaryTextColor,
		width: 'auto',
		'&.has-help': {
			right: 0,
			left: 'auto',
			transform: `translate(-15px, -40px)`,
		},
	},
	noLabelStyle: {
		marginBottom: 0,
	},
	alignCenter: {
		alignItems: 'center',
	},
	helpButtonStyle: {
		padding: 0,
	},
	helpContainerStyle: {
		position: 'absolute',
		right: 0,
		top: 10,
	},
	clearTextIconStyle: {
		color: theme.palette.text.secondary,
	},
	helpIconStyle: {
		width: 15,
		height: 15,
	},
});

FieldInputControl.propTypes = {
	helpPopupElement: PropTypes.element,
	variant: PropTypes.string,
	rows: PropTypes.number,
	showErrorAsPopover: PropTypes.bool,
	rowsMax: PropTypes.number,
	multiline: PropTypes.bool,
	inputClass: PropTypes.string,
	bordered: PropTypes.bool,
	containerClass: PropTypes.string,
	compact: PropTypes.bool,
	value: PropTypes.string,
	required: PropTypes.bool,
	onChangeCallback: PropTypes.func,
	input: PropTypes.object.isRequired,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
	help: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	meta: PropTypes.object,
	maxLength: PropTypes.number,
	label: PropTypes.string,
	fullWidth: PropTypes.bool,
	startAdornment: PropTypes.element,
	endAdornment: PropTypes.element,
	showCharCount: PropTypes.bool,
	autocomplete: PropTypes.string,
	doClearContent: PropTypes.func,
	showClearText: PropTypes.bool,
	popupPlacement: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	showHelpOnLabel: PropTypes.bool,
	classes: PropTypes.object,
	defaultValue: PropTypes.string,
};
FieldInputControl.defaultProps = {
	showClearText: false,
	showHelpOnLabel: false,
	autocomplete: null,
	defaultValue: null,
	showCharCount: false,
	variant: 'outlined',
	rows: 1,
	rowsMax: 5,
	showErrorAsPopover: true,
	fullWidth: true,
	bordered: true,
	multiline: false,
	popupPlacement: 'bottom-end',
};
export default withStyles(styles)(FieldInputControl);
